<template>
  <div>
    <v-autocomplete
      v-model="selectedUsers"
      :items="organizationUsers"
      :filter="customFilter"
      item-text="first_name"
      item-value="uuid"
      label="User"
      hide-selected
      return-object
      clearable
      multiple
    >
      <template v-slot:item="data">
        <v-list-item-icon>
          <v-icon>face</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-item-title>
          <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-slot:selection="data">
        <v-chip
          close
          @click:close="removeUser(data.item)"
        >{{data.item.first_name + ' ' + data.item.last_name}}</v-chip>
      </template>
    </v-autocomplete>
    <v-autocomplete
      v-model="selectedLocations"
      :items="locations"
      item-text="id"
      item-value="uuid"
      label="Locations"
      hide-selected
      return-object
      clearable
      multiple
    >
      <template v-slot:selection="data">
        <v-chip close @click:close="removeLocation(data.item)">{{data.item.id}}</v-chip>
      </template>
    </v-autocomplete>
    <v-autocomplete
      v-model="selectedRights"
      clearable
      :items="rights"
      item-text="label"
      item-value="value"
      label="Rights"
      hide-selected
      return-object
      multiple
    >
      <template v-slot:selection="data">
        <v-chip close @click:close="removeRight(data.item)">{{data.item.label}}</v-chip>
      </template>
    </v-autocomplete>
    <v-row>
      <v-btn color="success" @click="addUsersToLocations">
        <v-icon left>mdi-plus</v-icon>
        <span>Add</span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="removeUsersToLocations">
        <v-icon left>mdi-delete</v-icon>
        <span>Remove</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    organizationUsers: { type: Array, required: true },
    locations: { type: Array, required: true },
  },
  data() {
    return {
      selectedLocations: [],
      selectedUsers: [],
      selectedRights: [],
      rights: [
        { label: "Viewer", value: "viewers" },
        { label: "Editor", value: "editors" },
        { label: "Admin", value: "admins" },
      ],
    };
  },
  methods: {
    customFilter(item, queryText) {
      const textOne = item.first_name.toLowerCase();
      const textTwo = item.last_name.toLowerCase();
      const textThree = item.email.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1
      );
    },
    addUser() {
      this.$emit("addUser", this.selected);
    },
    removeLocation(item) {
      let index = this.selectedLocations
        .map(function (e) {
          return e.uuid;
        })
        .indexOf(item.uuid);
      if (index >= 0) this.selectedLocations.splice(index, 1);
    },
    removeRight(item) {
      let index = this.selectedRights
        .map(function (e) {
          return e.value;
        })
        .indexOf(item.value);
      if (index >= 0) this.selectedRights.splice(index, 1);
    },
    removeUser(item) {
      let index = this.selectedUsers
        .map(function (e) {
          return e.uuid;
        })
        .indexOf(item.uuid);
      if (index >= 0) this.selectedUsers.splice(index, 1);
    },
    addUsersToLocations() {
      this.$emit(
        "addUsersToLocations",
        this.selectedUsers,
        this.selectedLocations,
        this.selectedRights
      );
    },
    removeUsersToLocations() {
      this.$emit(
        "removeUsersToLocations",
        this.selectedUsers,
        this.selectedLocations,
        this.selectedRights
      );
    },
  },
};
</script>

<style>
</style>